import request from './request'

export function listPurchaseDelivery(data) {
  return request.post('/supply/purchase-deliveries/list', data)
}
export function getPurchaseDelivery(id) {
  return request.get('/supply/purchase-deliveries/' + id)
}
export function savePurchaseDelivery(data) {
  return request.post('/supply/purchase-deliveries', data)
}
export function updatePurchaseDelivery(data) {
  return request.post('/supply/purchase-deliveries/update', data)
}
export function deletePurchaseDelivery(ids) {
  return request.post('/supply/purchase-deliveries/delete', ids)
}
export function acceptPurchaseDelivery(arrivalId) {
  return request.post('/supply/purchase-deliveries/accept', { arrivalId })
}
export function unacceptPurchaseDelivery(arrivalId) {
  return request.post('/supply/purchase-deliveries/unaccept', { arrivalId })
}
